import { React, useEffect } from "react";

const Modal = ({ title, modalType = "info", bodyText, modalId }) => {
    useEffect(() => {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            const bootstrapModal = new window.bootstrap.Modal(modalElement);
            bootstrapModal.show();
        }
    }, [modalId]);

    const themeColors = {
        success: "#75c043",
        error: "#ff4d4d",
        info: "#3150a3",
    };

    const themeColor = themeColors[modalType] || themeColors.info;

    const getIconClass = () => {
        switch (modalType) {
            case "success":
                return "fa-solid fa-check"; // Success icon
            case "error":
                return "fa-solid fa-xmark"; // Error icon
            case "info":
            default:
                return "fa-solid fa-info"; // Info icon
        }
    };

    return (
        <>
            <div
                className="modal fade"
                id={modalId}
                tabIndex="-1"
                aria-labelledby={`${modalId}Label`}
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    style={{
                        maxWidth: "350px", // Reduced width
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            borderRadius: "10px",
                            maxHeight: "350px", // Reduced height
                            padding: "1rem", // Reduced padding
                        }}
                    >
                        <div
                            className="modal-header"
                            style={{
                                backgroundColor: themeColor,
                                color: "white",
                                padding: "0.8rem", // Reduced padding
                            }}
                        >
                            <h5 className="modal-title" id={`${modalId}Label`}>
                                {title}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style={{ filter: "invert(1)" }}
                            ></button>
                        </div>
                        <div
                            className="modal-body"
                            style={{
                                textAlign: "center",
                                padding: "1.2rem", // Adjusted padding
                            }}
                        >
                            <i
                                className={getIconClass()}
                                style={{
                                    fontSize: "2.2rem", // Reduced icon size
                                    color: themeColor,
                                    marginBottom: "0.8rem",
                                }}
                            ></i>
                            <p style={{ fontSize: "0.9rem" }}>{bodyText}</p> {/* Smaller font size */}
                        </div>
                        <div className="modal-footer" style={{ padding: "0.8rem" }}>
                            <button
                                type="button"
                                className="btn"
                                style={{
                                    backgroundColor: themeColor,
                                    fontWeight: "bold",
                                    color: "white",
                                    border: `1px solid ${themeColor}`,
                                    fontSize: "0.9rem",
                                    padding: "0.4rem 1rem", // Adjusted button size
                                }}
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
